module.exports = __webpack_public_path__ + "static/img/img42.eab365e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img42.png
// module id = Wd7E
// module chunks = 1